import React from 'react';
import privacyBanner from '../images/privacy-policy-banner.jpg';
import './PrivacyPolicy.css';

const FairPracticeCode = () => {
  return (
    <div className="privacy-page">
      <section className="privacy-banner">
        <div className="privacy-banner-wrapper">
          <div className="banner-image" style={{ backgroundImage: `url(${privacyBanner})` }}>
            <div className="banner-overlay">
              <h1 className="banner-heading">AMPIRE FINANCE</h1>
            </div>
          </div>
          <div className="banner-content">
            <h2 className="banner-title">FAIR PRACTICE CODE</h2>
          </div>
        </div>
      </section>

      <section className="privacy-content">
        <div className="privacy-wrapper">
          <div className="privacy-text">
            <h2 className="content-title">Fair Practice Code</h2>

            <h3 className="section-heading">1. Introduction</h3>
            <p>
              This Fair Practices Code ("FPC") has been formulated by Ampire Finance Private Limited ("Company") in accordance with RBI Master Direction - Non-Banking Financial Company – Systemically Important Non-Deposit taking Company and Deposit taking Company (Reserve Bank) Directions, 2016 and subsequent amendments. The objective of this Code is to ensure transparent, fair, and responsible lending practices and to promote good governance and customer confidence in the services offered by Ampire Finance Private Limited ("Company").
            </p>

            <h3 className="section-heading">2. Objectives of the Code</h3>
            <ul className="policy-list">
              <li>To promote fair and transparent dealings with customers.</li>
              <li>To ensure timely and accurate disclosures to borrowers.</li>
              <li>To provide clear mechanisms for grievance redressal.</li>
              <li>To protect borrower rights while maintaining the integrity of the institution.</li>
            </ul>

            <h3 className="section-heading">3. Application Scope</h3>
            <p>
              This Code applies to all products and services offered by the Company including but not limited to:
            </p>
            <ul className="policy-list">
              <li>Personal Loans</li>
              <li>Business Loans</li>
              <li>Consumer Durable Loans</li>
              <li>Auto and Two-Wheeler Loans</li>
              <li>Gold Loans</li>
              <li>Digital Lending</li>
              <li>Invoice Discounting</li>
            </ul>
            <p>
              This Code also applies to all lending conducted directly or through digital platforms, APIs, or third-party agents.
            </p>

            <h3 className="section-heading">4. Loan Appraisal and Disbursement</h3>
            <ul className="policy-list">
              <li>All communications to borrowers shall be in writing, in a language understood by the customer.</li>
              <li>Loan application forms will include necessary information to assess borrower needs and loan eligibility.</li>
              <li>Acknowledgement shall be provided for every loan application received.</li>
              <li>In case of loan rejection, reasons shall be conveyed in writing.</li>
              <li>Loan sanction terms, including interest rates, EMI, tenure, penalties, and processing fees will be transparently communicated in the sanction letter.</li>
              <li>Clearly communicate method of interest calculation (e.g., flat rate vs. reducing balance).</li>
              <li>Due diligence shall be conducted via internal/external credit assessment tools.</li>
              <li>The borrower will be given a sanction letter with full terms, including foreclosure terms, penal charges, security (if any), etc.</li>
              <li>Borrowers have the right to receive a copy of all signed documents.</li>
            </ul>

            <h3 className="section-heading">5. Interest Rate and Charges Policy</h3>
            <ul className="policy-list">
              <li>Interest rates are determined through a Board-approved policy.</li>
              <li>The borrower will be informed about the annualized rate of interest at the time of sanction.</li>
              <li>Processing charges, penal interest and other fees shall be clearly disclosed.</li>
              <li>Method of interest rate determination (risk-based pricing, benchmark-linked, etc.).</li>
              <li>Separate disclosures of processing fees, prepayment charges, default interest, etc.</li>
              <li>Annual Percentage Rate (APR) will be disclosed wherever applicable.</li>
            </ul>

            <h3 className="section-heading">6. Disbursement of Loans</h3>
            <ul className="policy-list">
              <li>Loan disbursement will be done only upon execution of all required agreements and submission of necessary documentation.</li>
              <li>Disbursement will be made through approved banking channels.</li>
              <li>All disbursements shall be made only into borrower's verified bank account.</li>
              <li>No disbursal will be made in cash.</li>
            </ul>

            <h3 className="section-heading">7. Post-Disbursement Supervision</h3>
            <ul className="policy-list">
              <li>Monitoring and follow-ups will be conducted in a manner that respects borrower dignity and privacy.</li>
              <li>Any changes in loan terms and conditions will be notified to the customer before implementation.</li>
              <li>Borrowers will receive reminders before EMIs are due.</li>
              <li>Mechanism for rescheduling of payments in genuine hardship cases (under RBI norms).</li>
              <li>No harassment or undignified collection practices shall be used.</li>
            </ul>

            <h3 className="section-heading">8. Grievance Redressal Mechanism</h3>
            <ul className="policy-list">
              <li>The Company will have a dedicated Customer Service Cell.</li>
              <li>Customers can contact our helpdesk or write to: <a href="mailto:support@ampirefinance.com" className="email-link">support@ampirefinance.com</a></li>
              <li>If not resolved within 15 working days, customers may escalate to the RBI Ombudsman.</li>
              <li>If unresolved, escalation to:
                <ul className="policy-list" style={{ marginTop: '12px' }}>
                  <li>NBFC Ombudsman / Integrated Ombudsman Scheme</li>
                  <li>RBI's Complaint Portal: <a href="https://cms.rbi.org.in" target="_blank" rel="noopener noreferrer" className="email-link">https://cms.rbi.org.in</a></li>
                </ul>
              </li>
            </ul>

            <h3 className="section-heading">9. Confidentiality and Privacy</h3>
            <ul className="policy-list">
              <li>Borrower data shall be collected only as required.</li>
              <li>Personal information shall not be shared with any third party without explicit consent, except as mandated by law.</li>
              <li>Data protection aligned with the Digital Personal Data Protection Act, 2023.</li>
              <li>Use of borrower data will be strictly restricted to operational or compliance needs.</li>
              <li>Periodic audits will be conducted to ensure data privacy.</li>
            </ul>

            <h3 className="section-heading">10. Language and Communication</h3>
            <ul className="policy-list">
              <li>All documentation and communication will be provided in English and/or in the vernacular language of the borrower, where required.</li>
              <li>All documentation and disclosures will be made in a language preferred by the customer, including online formats.</li>
              <li>SMS/email alerts for major transactions and repayment updates will be provided.</li>
            </ul>

            <h3 className="section-heading">11. General Provisions</h3>
            <ul className="policy-list">
              <li>The Code will be reviewed annually.</li>
              <li>Employees will be trained periodically to adhere to the principles of the FPC.</li>
              <li>FPC shall be published on the company website and displayed at all branch locations.</li>
              <li>The Code shall be reviewed annually by the Board of Directors.</li>
              <li>Internal audits will cover compliance with this Code.</li>
              <li>Training modules for new staff and regular refreshers shall include this Code.</li>
            </ul>

            <div className="effective-date">
              <p><strong>Approved On 15th April 2025</strong></p>
              <p><strong>By the Board of Directors (Digitally Signed)</strong></p>
              <p><strong>Fair Practice Code</strong></p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FairPracticeCode;
